
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { LayoutConfig, Units } from '../types'

@Component<LayoutTile>({})
export default class LayoutTile extends Vue {
    @Prop({ type: Number }) colidx!: number
    @Prop({ type: Number }) rowidx!: number
    @Prop({ type: Object }) layout!: LayoutConfig
    @Prop({ type: Object }) units!: Units

    get style() {
        const { colidx, rowidx, layout, units } = this
        return {
            top: (rowidx - 1) * layout.rowHeight + 'px', // units.v + '%',
            left: (colidx - 1) * units.width + 'px',
            width: units.width + 'px',
            height: layout.rowHeight + 'px', //units.v + '%',
        }
    }
}
